import {inject, InjectionToken} from '@angular/core';
export const APP_PACKAGE_ID = new InjectionToken<string>('appPackageId', {
    providedIn: 'root',
    factory: () => {
        return 'hub.mnlo.app';
    }
  });
  
  export const NOTIFICATION_APP_ID = new InjectionToken<string>('notificationAppId', {
    providedIn: 'root',
    factory: () => { 
        return ''; 
    }
  });
  
  export const NOTIFICATION_SAFARI_WEB_ID = new InjectionToken<string>('notificationSafariWebId', {
    providedIn: 'root',
    factory: () => {
        return 'web.onesignal.auto.*'; // onesignal mnlo safari web id
    }
  });